import React, { useState, useEffect } from 'react';
import { GetPersonalStats, GetMonthlySummary } from '../../Backend/ApiCalls';
import './PersonalStatsComponent.css';

const monthMap = {
    '01': 'Enero',
    '02': 'Febrero',
    '03': 'Marzo',
    '04': 'Abril',
    '05': 'Mayo',
    '06': 'Junio',
    '07': 'Julio',
    '08': 'Agosto',
    '09': 'Septiembre',
    '10': 'Octubre',
    '11': 'Noviembre',
    '12': 'Diciembre',
};

const drinkTypes = ['porro', 'cerveza', 'cigarro', 'cubata'];

const PersonalStatsComponent = () => {
    const [stats, setStats] = useState([]);

    useEffect(() => {
        async function fetchStats() {
            const { data } = await GetPersonalStats();
            setStats(data);
        }

        fetchStats();
    }, []);

    const groupedByDrink = drinkTypes.reduce((acc, drink) => {
        acc[drink] = stats
            .filter((item) => item.tipoBebida === drink)
            .reduce((acc, item) => {
                const monthYear = item.mes;
                const [year, monthNumber] = monthYear.split('-');
                const monthName = `${monthMap[monthNumber]} ${year}`;

                if (!acc[monthName]) {
                    acc[monthName] = 0;
                }
                acc[monthName] += item.total;
                return acc;
            }, {});
        return acc;
    }, {});

    return (
        <div className="personal-stats">
            <h1 className="stats-title">Estadísticas Personales 📊</h1>
            {drinkTypes.map((drink) => (
                <div key={drink} className="stats-section">
                    <h2 className="stats-drink-title">{drink.toUpperCase()}</h2>
                    <table className="stats-table">
                        <thead>
                            <tr>
                                <th>Mes</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedByDrink[drink]).map(([month, total], index) => (
                                <tr key={index}>
                                    <td>{month}</td>
                                    <td>{total}</td>
                                </tr>
                            ))}
                            <tr>
                                <td>
                                    <strong>Total</strong>
                                </td>
                                <td>
                                    <strong>
                                        {Object.values(groupedByDrink[drink]).reduce(
                                            (sum, total) => sum + total,
                                            0
                                        )}
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default PersonalStatsComponent;
